const { getCookie } = require("../../global/cookie");
const user = require("../../global/user");

const validateUser = async (app, cb = (data) => { return data; }) => {
  const aiwp_logged_in = getCookie("aiwp_logged_in");
  let objBody = { aiwp_logged_in , aiwp_app_id: app };
  objBody.aiwp_logged_in = aiwp_logged_in;
  objBody.user_event_data = {
      app_link: window.location.href,
      came_from : document.referrer
  }
  if (document.referrer != "") {
      objBody.user_event = "click-app"
  } else {
      objBody.user_event = "direct-access"
  }
  const url = require("../../global/url");

  const requestOptions = {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(objBody)
  };

  const auth = await fetch(`${url.api}/e/authenticate/v2`, requestOptions)
  .then(response => {
      return response.json();
    })
    .then(data => {
      user.email = data?.email || "";
      user.auth_version = data?.auth_version || "";
      user.subscription_type = data?.subscription_type || "";
      user.payment_interval = data?.payment_interval || "";
      user.is_free_user = data?.subscription_type ? false : true;
      cb(data);
    });
};

module.exports = validateUser;